(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'contentAnchors', {
            bindings: {
                dynamicBlocks: '<'
            },

            renderingOptions: {
                'anchors': {
                    inputs:    [
                        'dynamic-blocks="::customData.contentBlocks"'
                    ],
                    classes: [ 'block' ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>'
                }
            },

            templateUrl:    'app/views/partials/widgets/content-anchors.html',
            controller:     ContentAnchorsController,
            controllerAs:   'vm'
        });


    /**
     * Generates List of anchor links to navigate user within a single content
     * page. Order of the dynamic blocks is respected when generating the list.
     *
     * @param {ng.IScope} $scope
     * @param {LoggerFactory} LoggerFactory
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {Utils} Utils
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     */
    function ContentAnchorsController(
        $scope,
        LoggerFactory,
        ContentSwitchingService,
        Utils,
        TEXTS,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {Logger} */
        //var logger = LoggerFactory.createLogger( 'ContentAnchorsController' );


        /** @constant */
        var _ = TEXTS.GENERIC.CONTENT_ANCHORS,

        ALLOWED_ANCHORS_CONFIGS = {
            'requirements': { /* = `contentType` */
                id: undefined /* = `id` to scroll to */
            },
            'entry-requirements': {
                id: undefined
            },

            'content-plain':       {},
            'content-plain-links': {},
            'intro-postgrad':      {},

            'majors': {
                id:    CONFIG.ANCHORS.MAJORS_SELECTION,
                label: _.ANCHOR_MAJORS_LABEL
            }
        };





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope.Utils    = Utils;
        $scope._        = _;

        $scope.CONFIG   = CONFIG;

        $scope.contentSwitchingService = ContentSwitchingService;







        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        vm.$onInit = function() {
            initAnchorList();
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        function initAnchorList() {
            if ( vm.dynamicBlocks == 0 ) return;

            vm.anchors = vm.dynamicBlocks.map( function( dynamicBlock ){
                if ( ALLOWED_ANCHORS_CONFIGS.hasOwnProperty( dynamicBlock.contentType ) ) {
                    var anchorConfig = ALLOWED_ANCHORS_CONFIGS[ dynamicBlock.contentType ];

                    // No heading or pre-defined label - skip!
                    if ( !dynamicBlock.asset_contents.heading && !anchorConfig.label ) return;

                    // If `id` is not defined - turn heading into a 'slug'
                    var anchorId = angular.isDefined( anchorConfig.id ) ? anchorConfig.id : Utils.convertToSlug( dynamicBlock.asset_contents.heading );

                    return {
                        id:     anchorId,
                        label:  dynamicBlock.asset_contents.heading ? dynamicBlock.asset_contents.heading : anchorConfig.label,
                        restrictedTo: dynamicBlock.region != '' ? dynamicBlock.region : null
                    };
                } else {
                    return;
                }
            }).filter( function( nonEmptyItem ){ return Boolean( nonEmptyItem ); });
        }
    }



    ContentAnchorsController.$inject = [ '$scope', 'LoggerFactory', 'ContentSwitchingService', 'Utils', 'TEXTS', 'CONFIG' ];
})();
